import { render, staticRenderFns } from "./TitanAccordion.vue?vue&type=template&id=11be464c&scoped=true"
import script from "./TitanAccordion.vue?vue&type=script&lang=js"
export * from "./TitanAccordion.vue?vue&type=script&lang=js"
import style0 from "./TitanAccordion.vue?vue&type=style&index=0&id=11be464c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be464c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11be464c')) {
      api.createRecord('11be464c', component.options)
    } else {
      api.reload('11be464c', component.options)
    }
    module.hot.accept("./TitanAccordion.vue?vue&type=template&id=11be464c&scoped=true", function () {
      api.rerender('11be464c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/TitanAccordion.vue"
export default component.exports